import { Check, Clock3, LockKeyhole } from 'lucide-react'

interface StatusLabelProps {
  status: '待完成' | '已完成' | '待诊断' | '学习中' | '待复习' | '已掌握' | '未解锁'
}

export function StatusLabel({ status }: StatusLabelProps) {
  const isComplete = status === '已完成' || status === '已掌握'
  const isLocked = status === '未解锁'
  const Icon = isComplete ? Check : isLocked ? LockKeyhole : Clock3

  return (
    <span
      className={`status-label ${isComplete ? 'status-label--complete' : ''} ${
        isLocked ? 'status-label--locked' : ''
      }`.trim()}
    >
      <Icon size={14} strokeWidth={1.8} aria-hidden="true" />
      {status}
    </span>
  )
}
